import { render, staticRenderFns } from "./SubscriptionCompleted.vue?vue&type=template&id=38b9f1a4&scoped=true"
import script from "./SubscriptionCompleted.vue?vue&type=script&lang=ts"
export * from "./SubscriptionCompleted.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionCompleted.vue?vue&type=style&index=0&id=38b9f1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9f1a4",
  null
  
)

export default component.exports